import React, { useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import Typogaphy from "../Typography/Typography";
import { useDeleteNote } from "../../hooks/useCrm";
import { useDeleteTarget } from "../../hooks/useManagement";
import { useNavigate } from "react-router-dom";

export const DeleteTargetModal = ({ show, handleClose, targetId }) => {
  const navigate = useNavigate();
  const [button] = useState(false);
  const { mutateAsync: deleteTarget, isLoading } = useDeleteTarget();
  const handleDeleteTarget = async (datom) => {
    await deleteTarget({ sale_target_id: datom }).then(() =>
      navigate("/dashboard/management/Targeting")
    );
  };
  return (
    <BootstrapModal
      modaltitle="حذف تارگت"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <Typogaphy size="15px">آیا از حذف این تارگت مطمئن هستید؟</Typogaphy>
        </div>
        <div className="col-6 mt-2">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleDeleteTarget(targetId);
              handleClose();
            }}
          >
            بله
          </Button>
        </div>
        <div className="col-6 mt-2">
          <Button bgColor="#f1416c" color="#fff" onclick={handleClose}>
            خیر
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
